import { z } from 'zod';

export const loginSchema = z.object({
    adminId: z
        .string()
        .min(1, 'Admin ID를 입력해주세요.')
        .min(3, 'Admin ID는 3자 이상이어야 합니다.')
        .regex(
            /^[a-zA-Z0-9_-]+$/,
            'Admin ID는 영문, 숫자, 언더스코어, 하이픈만 사용 가능합니다.',
        ),
    adminPw: z
        .string()
        .min(1, '비밀번호를 입력해주세요.')
        .min(6, '비밀번호는 6자 이상이어야 합니다.'),
});

export type LoginFormData = z.infer<typeof loginSchema>;

export const idLoginSchema = z.object({
    userId: z.string().min(1, '아이디를 입력해주세요.'),
    userPw: z.string().min(1, '비밀번호를 입력해주세요.'),
});

export type IdLoginFormData = z.infer<typeof idLoginSchema>;
